import React, { useEffect } from 'react'

import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';

import './TreePopup.css'
import IndicatorsPool from '../../js/IndicatorsPool';
import ParametersPool from '../../js/ParametersPool';
import { store } from '../../stores/store';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';

const NodeComp = ({node}) => {
  let {id} = node



  let ind = IndicatorsPool.getIndicator(id)
  let indName = ind.title
  // let indValue = Math.round(IndicatorsPool.getIndicatorValue(id) * 100) / 100
  let indValue = IndicatorsPool.getIndicatorValue(id, true)

  let weight = Math.floor( ParametersPool.getDef(id) * 100)
  return (
  <div className="chart-node">
    <div className="chart-node-title">{indName}</div>
    <div className="chart-node-value">{indValue}</div>
    {!node.toplevel && <span className="weight">{weight}%</span>}
  </div>)
}


const TreePopup = ({data}) => {

  function onClose() {
    PopupStore.close(POPUPS_IDS.TREES)
  }
  function handleKeyDown(e) { if(e.keyCode === 27) onClose() }
  useEffect(()=> {
      window.addEventListener('keydown', handleKeyDown)
      return () => { window.removeEventListener('keydown', handleKeyDown) }
    }, [])

  return (
    <div className="overlay" onClick={onClose}>
      <div className="TreePopup" onClick={(e)=>{e.stopPropagation()}}>
        <div className="TreePopup-title">
          {data.title}
          <div className="TreePopup-close" onClick={onClose} />
        </div>

        <div className="TreePopup-content">
          <OrgChart tree={data.data[0]} NodeComponent={NodeComp} />
        </div>

      </div>
    </div>
  );
};

export default TreePopup;
